import { Card, CardTitle, Table } from '../../patient-profile-page.styles';

import { CardContent, Skeleton, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

function LoadingSkeleton() {
  return (
    <Card>
      <CardContent>
        <CardTitle>
          <Skeleton variant="text" width="60%" height={38} />
        </CardTitle>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '30%' }}>Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>PMS ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell style={{ width: 0 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(3)].map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton variant="text" width="100%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="100%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="100%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="100%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="100%" />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width="149px" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default LoadingSkeleton;
